/** CSS reference pixel at 96 DPI (same constant TwinShell uses for scale). */
export const METERS_PER_CSS_PIXEL = 0.0002645833333;

export const MM_PER_INCH = 25.4;
export const CSS_PX_PER_MM = 96 / MM_PER_INCH;
/** Typographic points, the unit ArcGIS Pro reports symbol sizes in. */
export const PT_PER_INCH = 72;

export function mmToPt(mm: number): number {
  return (mm * PT_PER_INCH) / MM_PER_INCH;
}

export function ptToMm(pt: number): number {
  return (pt * MM_PER_INCH) / PT_PER_INCH;
}

export function mmToScreenPx(mm: number, pageZoom: number): number {
  return mm * CSS_PX_PER_MM * pageZoom;
}

export function screenPxToMm(px: number, pageZoom: number): number {
  if (pageZoom === 0) return 0;
  return px / (CSS_PX_PER_MM * pageZoom);
}

export function pageSizePx(
  widthMm: number,
  heightMm: number,
  pageZoom: number,
): { width: number; height: number } {
  return {
    width: mmToScreenPx(widthMm, pageZoom),
    height: mmToScreenPx(heightMm, pageZoom),
  };
}
